window.openNav = function() {
    if (document.getElementById("myNav").style.width == "0%" || document.getElementById("myNav").style.width == 0) {
        document.getElementById("myNav").style.width = "75%";
    }
    else {
        document.getElementById("myNav").style.width = "0%";
    }
}

window.closeNav = function() {
    document.getElementById("myNav").style.width = "0%";
}

$(window).scroll(function(){
    var scroll = $(window).scrollTop();
    if (scroll > 100) {
        $("nav.navbar").addClass('affix-top');
        $(".logo-affix").hide();
        $(".logo-affix-top").show();
    }
    else{
        $("nav.navbar").removeClass('affix-top');
        $(".logo-affix").show();
        $(".logo-affix-top").hide();
    }
})
